import React from 'react';
import ReactDOM from 'react-dom/client';
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider} from '@shopify/polaris';
import App from './App';
import {AppContextProvider} from './context/AppContext';
import reportWebVitals from './reportWebVitals';
import {FALSE_STR} from './constants/constants';
import {commonConditionCheck} from './utils/helper';
import '@shopify/polaris/build/esm/styles.css';
import './index.css';

//Create root for the application
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
//render the application in root element
//StrictMode is a tool that highlights potential issues in a programme
/*App provider is a required component that enables sharing global 
 settings throughout the hierarchy of your application
*/
//ContextProvider allows consuming components to subscribe to context changes
//App Bridge Config is used to make the App embedded in shopify

const appClientId: string | undefined = process.env.REACT_APP_SHOPIFY_APP_CLIENT_ID;
const appEnableErrorLog: string | undefined = process.env.REACT_APP_SHOPIFY_ENABLE_ERR_LOG_FEATURE;
const appSupplementaryBaseURL: string | undefined = process.env.REACT_APP_SHOPIFY_APP_SUPPLEMENTARY_BASE_URL;
const appEnableDownloadXLSOption: string | undefined = process.env.REACT_APP_SHOPIFY_ENABLE_DOWNLOAD_ERR_LOGS;
const appEnableIDPProvider: string = process.env.REACT_APP_SHOPIFY_ENABLE_IDP_PROVIDER ?? '';
const appEnableSalesChannel: string = process.env.REACT_APP_SHOPIFY_ENABLE_SALES_CHANNEL ?? '';
console.log("Shopify App Client ID from index.tsx", process.env.REACT_APP_SHOPIFY_APP_CLIENT_ID);
root.render(
  <React.StrictMode>
      <AppProvider i18n={enTranslations}>
        <AppContextProvider>
          <App
            appClientId={appClientId ?? ''}
            appEnableErrorLog={appEnableErrorLog ?? ''}
            appSupplementaryBaseURL={appSupplementaryBaseURL ?? ''}
            appEnableDownloadXLSOption={appEnableDownloadXLSOption ?? ''}
            appEnableIDPProvider={commonConditionCheck(
              appEnableIDPProvider !== '', appEnableIDPProvider, FALSE_STR)}
            appEnableSalesChannel={commonConditionCheck(
              appEnableSalesChannel !== '', appEnableSalesChannel, FALSE_STR)}/>
        </AppContextProvider>
      </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
